import { Check } from 'lucide-react';
import React from 'react';
import styles from './PricingModal.module.scss';

export interface PlanData {
    name: string;
    price: string | number;
    description: string;
    buttonText: string;
    isPopular?: boolean;
    isCustom?: boolean;
    features: string[];
}

interface PricingCardProps {
    plan: PlanData;
    onAction: () => void;
    loading?: boolean;
    disabled?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
    plan, onAction, loading, disabled 
}) => {
    return (
        <div 
            className={`${styles.card} ${plan.isPopular ? styles.popularCard : ''}`}
        >
            {plan.isPopular ? (
                <div className={styles.popularBadge}>
                    Most Popular
                </div>
            ) : null}

            <div className={styles.planHeader}>
                <div className={styles.priceContainer}>
                    <h3 className={styles.planName}>
                        {plan.name}
                    </h3>
                </div>
                
                <div className={styles.priceWrapper}>
                    {plan.isCustom ? (
                        <span className={styles.customPrice}>Custom</span>
                    ) : (
                        <>
                            <span className={styles.price}>
                                $
                                {plan.price}
                            </span>
                            <span className={styles.period}>/mo</span>
                        </>
                    )}
                </div>
                
                <p className={styles.description}>{plan.description}</p>
            </div>

            <button 
                onClick={onAction}
                disabled={loading || disabled}
                className={`${styles.actionButton} ${
                    plan.isPopular ? styles.primaryButton : styles.secondaryButton
                }`}
                style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            >
                {loading ? 'Processing...' : plan.buttonText}
            </button>

            <div className={styles.featuresList}>
                <ul className={styles.featureListUl}>
                    {plan.features.map((feature, i) => {
                        const isHeader = feature === 'Everything in Basic, plus';
                        return (
                            <li 
                                key={i} 
                                className={styles.featureItem}
                                style={isHeader ? {
                                    background: 'transparent', paddingLeft: 0, fontWeight: 'bold' 
                                } : {}}
                            >
                                {!isHeader && (
                                    <div className={styles.checkCircle}>
                                        <Check size={12} className={styles.checkIcon} strokeWidth={4} />
                                    </div>
                                )}
                                <span className={styles.featureText}>
                                    {feature}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default PricingCard;
